import * as actionTypes from '../Register_action.types';

const initialState = {
  loggingIn: false,
  leaves: [],
  error: null,
  message: '',
};

const leaveReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CREATE_LEAVE_MASTER_REQUEST:
    case actionTypes.UPDATE_LEAVE_MASTER_REQUEST:
    case actionTypes.DELETE_LEAVE_MASTER_REQUEST:
    case actionTypes.UPLOAD_LEAVE_MASTER_REQUEST:
    case actionTypes.MULTIDELETE_LEAVE_MASTER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.UPDATE_LEAVE_MASTER_SUCCESS:
    case actionTypes.CREATE_LEAVE_MASTER_SUCCESS:
    case actionTypes.DELETE_LEAVE_MASTER_SUCCESS:
    case actionTypes.UPLOAD_LEAVE_MASTER_SUCCESS:
    case actionTypes.MULTIDELETE_LEAVE_MASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
      };
    case actionTypes.GET_LEAVE_MASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        leave: action.payload,

      }
    case actionTypes.GET_LEAVE_MASTER_FAILURE:
    case actionTypes.CREATE_LEAVE_MASTER_FAILURE:
    case actionTypes.UPDATE_LEAVE_MASTER_FAILURE:
    case actionTypes.DELETE_LEAVE_MASTER_FAILURE:
    case actionTypes.UPLOAD_LEAVE_MASTER_FAILURE:
    case actionTypes.MULTIDELETE_LEAVE_MASTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default leaveReducer
